import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propShape, propStr } from '../../../helpers/custom-prop-types';
import { validatePhoneNumber } from '../../../validate/profile';
import MultiInputFields from '../Common/Fields/MultiInputFields';
const PhoneNumberFields = ({ form, name1, name2, name3 }) => (_jsx(MultiInputFields, { form: form, settings: [
        {
            maxLength: 4,
            name: name1,
            placeholder: '03',
            type: 'tel',
            validate: validatePhoneNumber,
        },
        {
            maxLength: 4,
            name: name2,
            placeholder: '2345',
            type: 'tel',
            validate: validatePhoneNumber,
        },
        {
            maxLength: 4,
            name: name3,
            placeholder: '6789',
            type: 'tel',
            validate: validatePhoneNumber,
        },
    ], spacer: '- ', wrapClassName: 'form-flex-split is-third-nowrap-form' }));
PhoneNumberFields.propTypes = {
    form: propShape().isRequired,
    name1: propStr(),
    name2: propStr(),
    name3: propStr(),
};
PhoneNumberFields.defaultProps = {
    name1: 'phone1',
    name2: 'phone2',
    name3: 'phone3',
};
export default PhoneNumberFields;
